import { render, staticRenderFns } from "./r-global-config-view.vue?vue&type=template&id=06fe40bf"
import script from "./r-global-config-view.vue?vue&type=script&lang=js"
export * from "./r-global-config-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06fe40bf')) {
      api.createRecord('06fe40bf', component.options)
    } else {
      api.reload('06fe40bf', component.options)
    }
    module.hot.accept("./r-global-config-view.vue?vue&type=template&id=06fe40bf", function () {
      api.rerender('06fe40bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/global-config/r-global-config-view.vue"
export default component.exports